import { FC } from 'react';

const Footer: FC = () => {
  return (
    <footer className="print-hide mt-auto px-6 md:px-10 py-6 border-t border-theme-border">
      <div className="flex items-center justify-center gap-2">
        <span className="text-content-muted text-xs font-medium">&copy; 2026 h.lab por</span>
        <img src="/hcompany-logo.png" alt="h.company" className="h-5 w-auto" />
      </div>
    </footer>
  );
};

export default Footer;
